import { combineReducers } from '@reduxjs/toolkit';
import { reducer as approvalReducer } from '../slices/approval';
import { reducer as conditionReducer } from '../slices/condition';
import { reducer as confirmContinuationReducer } from '../slices/confirmContinuation';
import { reducer as deliveryLocationReducer } from '../slices/deliveryLocation';
import { reducer as informationReducer } from '../slices/information';
import { reducer as inventoryJobReducer } from '../slices/inventoryJob';
import { reducer as inventoryStatusReducer } from '../slices/inventoryStatus';
import { reducer as manageTradingCompanyInformationReducer } from '../slices/manageTradingCompanyInformation';
import { reducer as millSheetSearchReducer } from '../slices/millSheetSearch';
import { reducer as newsReducer } from '../slices/news';
import { reducer as optionsReducer } from '../slices/options';
import { reducer as organizationReducer } from '../slices/organization';
import { reducer as organizationBaseReducer } from '../slices/organizationBase';
import { reducer as ownInfoReducer } from '../slices/ownInfo';
import { reducer as sessionReducer } from '../slices/session';
import { reducer as tradingCompanyInformationReducer } from '../slices/tradingCompanyInformation';
import { reducer as userReducer } from '../slices/user';

const rootReducer = combineReducers({
  approval: approvalReducer,
  condition: conditionReducer,
  confirmContinuation: confirmContinuationReducer,
  deliveryLocation: deliveryLocationReducer,
  information: informationReducer,
  inventoryJob: inventoryJobReducer,
  inventoryStatus: inventoryStatusReducer,
  manageTradingCompanyInformation: manageTradingCompanyInformationReducer,
  millSheetSearch: millSheetSearchReducer,
  news: newsReducer,
  options: optionsReducer,
  organization: organizationReducer,
  organizationBase: organizationBaseReducer,
  ownInfo: ownInfoReducer,
  session: sessionReducer,
  tradingCompanyInformation: tradingCompanyInformationReducer,
  user: userReducer,
});

export default rootReducer;
